module.exports = __webpack_public_path__ + "img/129ne.e6a256ae.svg";